import { useEffect, useState } from 'react'
import { config } from '../../../../components/Init/Init'
import { useGetAccountDetails } from '../../../../hooks/accountHooks'

export const usePlayerPIIFetchAccountDetails = ({ piiDataRequired, piiDataRequiredChecked }) => {
  const { getAccountDetails } = useGetAccountDetails()
  const [playerPIIDataLoading, setPlayerPIIDataLoading] = useState(false)

  useEffect(() => {
    if (config.enableSweepstakes && piiDataRequiredChecked && !piiDataRequired) {
      setPlayerPIIDataLoading(true)
      // we need to grab the country from the server, as submitting the pii doesn't store it on the client immediately

      getAccountDetails({
        successCallback: () => {
          setPlayerPIIDataLoading(false)
        },
        failCallback: errorReason => {
          setPlayerPIIDataLoading(false)

          console.log('[Casino] Account Details - ERROR!', errorReason)
        }
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [piiDataRequired, piiDataRequiredChecked])

  return { playerPIIDataLoading }
}
